import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=294d78ac&scoped=true&"
import script from "./favorite.js?vue&type=script&lang=js&"
export * from "./favorite.js?vue&type=script&lang=js&"
import style0 from "./global.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./favorite.scss?vue&type=style&index=1&id=294d78ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294d78ac",
  null
  
)

export default component.exports